module.exports = __webpack_public_path__ + "img/15.92d9a1a8.webp";